import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthByPasswordBodyType,
  AuthByPasswordResponseType
} from "@website/widget/login/services/auth-by-password/auth-by-password.types";

export const AuthByPasswordUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/password`;

export const AuthByPasswordService = (
  body: AuthByPasswordBodyType
): Promise<AuthByPasswordResponseType> =>
  fetcher({
    url: AuthByPasswordUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
